import { Component } from 'react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import styled from 'styled-components';

import { InputFloatingPlaceholder } from '../common/InputFloatingPlaceholder';
import { Modal } from '../common/Modal';

interface MileageModalProps {
	isOpen: boolean;
	insertedMileage: number | null;
	pictureMileage: string;
	onClose: (insertedMileage: number | null) => void;
	onConfirm: (insertedMileage: number | null) => void;
	onReverse: () => void;
	intl: IntlShape;
}

interface MileageModalState {
	insertedMileage: string;
	pictureMileage: string;
}

export class MileageModal extends Component<MileageModalProps, MileageModalState> {
	constructor(props: MileageModalProps) {
		super(props);
		this.state = {
			pictureMileage: props.pictureMileage,
			insertedMileage: props.insertedMileage?.toString() ?? '',
		};
	}

	checkMileage(text: string, insertedMileage: string | null): string | null {
		if (text == null && insertedMileage == null) {
			return null;
		}

		const numberRegex: string = String.raw`^0*\d+$`;
		const MILEAGE_REGEX: string = '^[0-9]{0,6}$';
		let mileageProvided: string | null = null;

		if (text && new RegExp(numberRegex).test(text)) {
			const inputNumber = Number.parseInt(text, 10);

			if (inputNumber > 999999) {
				mileageProvided = insertedMileage;
			} else if (text && new RegExp(MILEAGE_REGEX).test(text)) {
				mileageProvided = text;
			}
		}

		return mileageProvided;
	}

	onMileageTextChanged(ev: any, ...args: any[]) {
		const text = ev.target.value;

		const mileage: string | null = this.checkMileage(text, this.state.insertedMileage);

		this.setState({ insertedMileage: mileage ?? '' });
	}

	onConfirm = () => {
		if (this.props.onConfirm) {
			const mileage =
				this.state.insertedMileage != null ? Number.parseInt(this.state.insertedMileage) : null;

			this.props.onConfirm(mileage);
		}
	};

	onReverse = () => {
		if (this.props.onReverse) {
			this.props.onReverse();
		}
	};

	render() {
		const { intl } = this.props;

		return (
			<Modal
				isOpen={this.props.isOpen}
				closeOnBackdropClick={false}
				onClose={this.onConfirm}
				header={
					<span className="mileage-modal-header">
						<FormattedMessage id="mileageModal.headline" />
					</span>
				}
				footer={
					<div className="mileage-modal-footer-container">
						<button className="mileage-modal-button-reverse" onClick={this.onReverse}>
							<FormattedMessage id="button.reverse" />
						</button>
						<button className="mileage-modal-button-confirm" onClick={this.onConfirm}>
							<FormattedMessage id="button.confirm" />
						</button>
					</div>
				}
			>
				{
					<MileageContainer className="mileage-modal-container">
						<StyledDiv className="mileage-modal-body">
							<FormattedMessage id="mileageModal.paragraph" />
						</StyledDiv>
						<StyledDiv className="mileage-modal-picture-mileage">
							<PictureMileageHeader className="mileage-moda-picture-mileage-value-header">
								<FormattedMessage id="mileageModal.pictureMileage" />
							</PictureMileageHeader>
							<PictureMileage className="mileage-moda-picture-mileage-value">
								{this.state.pictureMileage}
							</PictureMileage>
						</StyledDiv>
						<InputFloatingPlaceholder
							className="mileage-modal-input"
							type="string"
							pattern={'[0-9]*'}
							placeholder={intl.formatMessage({ id: 'mileageModal.insertedMileagePlaceholder' })}
							isValid={true}
							showInvalid={false}
							isRequired={false}
							value={this.state.insertedMileage}
							onChange={(e) => this.onMileageTextChanged(e)}
						/>
					</MileageContainer>
				}
			</Modal>
		);
	}
}

export default injectIntl(MileageModal);

const MileageContainer = styled.div`
	display: grid;
	justify-content: center;
	grid-row-gap: 1rem;
`;

const StyledDiv = styled.div`
	margin-bottom: 2rem;
	width: 100%;
	border-radius: 3px;
`;

const PictureMileageHeader = styled.span`
	font-size: 12px;
`;

const PictureMileage = styled.div`
	font-size: 16px;
`;
